export default __webpack_public_path__ + "static/media/rose.12aee74e.svg";